module.exports = __webpack_public_path__ + "static/media/cq_asterisco.45ecc367.svg";